/**
 * Home, chapter 04 — "Who is under the hood?": about, as a player card.
 * The hero stands on a pedestal under a spotlight. The markup is the
 * server's (templates/site/sections/home/player.html.twig).
 *
 * @module sections/home/player
 */

import { REDUCED_MOTION } from '../../config.js';
import { $ } from '../../lib/dom.js';
import { gsap } from '../../lib/gsap.js';

/**
 * The spotlight comes on and the hero draws his wireframe side as the stage
 * comes in; the balance finds its middle.
 *
 * @param {HTMLElement} player
 */
export function animate(player) {
    if (REDUCED_MOTION) {
        return;
    }

    const stage = $('.player__stage', player);
    const marker = $('[data-balance]', player);

    if (stage) {
        gsap.timeline({
            defaults: { ease: 'none' },
            scrollTrigger: { trigger: stage, start: 'top 85%', end: 'center 45%', scrub: true },
        })
            .fromTo(
                $('[data-player-light]', player),
                { opacity: 0, scaleY: 0.4 },
                { opacity: 1, scaleY: 1, duration: 0.4 },
                0,
            )
            .fromTo(
                player.querySelectorAll('.hoodie__stroke'),
                { drawSVG: '0%' },
                { drawSVG: '100%', duration: 0.7 },
                0.2,
            );
    }

    if (marker) {
        gsap.fromTo(
            marker,
            { left: '4%' },
            {
                left: '50%',
                duration: 1.8,
                ease: 'elastic.out(1, 0.45)',
                scrollTrigger: { trigger: marker, start: 'top 92%', once: true },
            },
        );
    }
}
